import Vue from 'vue';
import Router from 'vue-router';
import User from '@/components/User';
import Klasses from '@/components/Klasses';
import Notices from '@/components/Notices';
import Schools from '@/components/Schools';
import Students from '@/components/Students';
import Tasks from '@/components/Tasks';
import Customer from '@/components/Customer';
import Home from '@/components/Home';
import StudentDetail from '@/components/StudentDetail';
import UserDetail from '@/components/UserDetail';
import Login from '@/components/Login';
import KlassDetail from '@/components/KlassDetail';
import NoticeDetail from '@/components/NoticeDetail';
import TaskDetail from '@/components/TaskDetail';
import Teaching from '@/components/Teaching';
import Section from '@/components/Section';
import AnswerBook from '@/components/AnswerBook';
import ChapterList from '@/components/ChapterList';
import MakeTestCard from '@/components/MakeTestCard';
import LabelManagement from '@/components/LabelManagement';
import BookStatistics from '@/components/BookStatistics';
import Bluetooth from '@/components/Bluetooth';
import StudentBluetooth from '@/components/StudentBluetooth';
import TeacherJudge from '@/components/TeacherJudge';
import StudentBluetoothDetails from '@/components/StudentDetails'
import QuestionBank from '@/components/QuestionBank'
import TeachingChapterList from '@/components/TeachingChapterList'
import TeachingBorder from '@/components/TeachingBorder'
import TeachingBorderList from '@/components/TeachingBorderList'

import OCRSetting from '@/components/OCRSetting';
import OCRSettingDetail from '@/components/OCRSettingDetail'
import OCRCard from '@/components/OCRCard'
import OCRConfig from '@/components/OCRConfig'
import OCRCardDetails from '@/components/OCRCardDetails'
import OCRCardItemDetails from '@/components/OCRCardItemDetails'
import VideoFilter from '@/components/VideoFilter'

Vue.use(Router);

let router = new Router({
  routes: [{
      path: '/customer',
      name: "Home",
      component: Home,
      children: [{
          path: '/customer',
          name: 'Customer',
          component: Customer
        },
        {
          path: '/user',
          name: 'User',
          component: User
        },
        {
          path: '/schools',
          name: 'Schools',
          component: Schools
        },
        {
          path: '/klasses',
          name: 'Klasses',
          component: Klasses
        },
        {
          path: '/students',
          name: 'Students',
          component: Students,
        },
        {
          path: '/notices',
          name: 'Notices',
          component: Notices
        },
        {
          path: '/tasks',
          name: 'Tasks',
          component: Tasks
        },
        {
          path: '/students/detail',
          name: "StudentDetail",
          component: StudentDetail
        },
        {
          path: '/user/detail',
          name: "UserDetail",
          component: UserDetail
        },
        {
          path: '/klasses/detail',
          name: "KlassDetail",
          component: KlassDetail
        },
        {
          path: '/notices/detail',
          name: "NoticeDetail",
          component: NoticeDetail
        },
        {
          path: '/tasks/detail',
          name: 'TaskDetail',
          component: TaskDetail
        },
        {
          path: '/teaching',
          name: "Teaching",
          component: Teaching
        },
        {
          path: '/teaching/questionbank',
          name: 'QuestionBank',
          component: QuestionBank
        },
        {
          path: '/teaching/detail',
          name: "Section",
          component: Section
        },
        {
          path: '/answer',
          name: "Answer",
          component: AnswerBook
        },
        {
          path: '/answer/chapter/:id',
          name: "ChapterList",
          component: ChapterList
        },
        {
          path: '/answer/questionbank',
          component: QuestionBank
        },
        {
          path: "/tags",
          name: "LabelManagement",
          component: LabelManagement
        },
        {
          path: "/bookstatistics",
          name: "BookStatistics",
          component: BookStatistics
        },
        {
          // path:'/bluetooth/:page/:name?',
          path: '/bluetooth',
          name: "Bluetooth",
          component: Bluetooth,
        },
        {
          path: '/studentbluetooth',
          name: "StudentBluetooth",
          component: StudentBluetooth
        },
        {
          path: "/teacherJudgebluetooth",
          name: "TeacherJudge",
          component: TeacherJudge
        },
        {
          path: '/studentbluetoothDetails',
          name: "StudentBluetoothDetails",
          component: StudentBluetoothDetails
        },
        {
          path: '/TeachingBorderList',
          name: 'TeachingBorderList',
          component: TeachingBorderList
        },
        {
          path: '/TeachingBorderList/teachingChapterList/:id',
          name: 'teachingChapterList',
          component: TeachingChapterList
        },
        {
          path: '/TeachingBorderList/teachingBorder/:id/:src',
          name: 'teachingBorder',
          component: TeachingBorder
        },
        {
          path: '/OCRSetting',
          name: "OCRSetting",
          component: OCRSetting
        },
        {
          path: '/OCRCard',
          name: "OCRCard",
          component: OCRCard
        },
        {
          path: '/OCRCard/:id',
          name: "OCRCardDetails",
          component: OCRCardDetails,
        },
        {
          path: '/OCRCardItem',
          name: "OCRCardItemDetails",
          component: OCRCardItemDetails
        },
        {
          path: '/OCRConfig',
          name: "OCRConfig",
          component: OCRConfig
        },
        {
          path: '/OCRSetting/:id',
          name: "OCRSettingDetail",
          component: OCRSettingDetail
        },
        {
          path:'/videoFilter',
          name:'VideoFilter',
          component:VideoFilter
        }
      ]
    },
    {
      path: '/answer/MakeTestCard',
      name: "MakeTestCard",
      component: MakeTestCard
    },
    {
      path: '/',
      name: "Login",
      component: Login
    },


  ]
});
router.beforeEach((to, from, next) => {
  if (from.name == 'OCRCardItemDetails' && to.name == 'OCRCardDetails') {
    to.meta.ifDoFresh = true;
    console.log(to.meta.ifDoFresh);
  }
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js